module.exports = __webpack_public_path__ + "img/oh-elvas-footer.e363ccc5.svg";